import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { SelectionMode } from '../../dataViews/DynamicTree';

import StaticOverlayTree from '../../dataViews/StaticOverlayTree';

const RoleAssignmentSelector = ({ selection, models, ...rest }) => (
  <StaticOverlayTree
    selectionMode={SelectionMode.MULTI}
    staticModels={models}
    tree="RoleAssignmentSelector"
    value={selection}
    {...rest}
  />
);

RoleAssignmentSelector.propTypes = {
  models: PropTypes.arrayOf(PropTypes.object),
  selection: PropTypes.object,
};

RoleAssignmentSelector.defaultProps = {
  models: [],
  selection: null,
};

export default memo(RoleAssignmentSelector);
